"use strict";

exports.__esModule = true;
exports.LinkButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["exact", "end", "to", "icon", "rightIcon", "alignText", "fill", "large", "loading", "minimal", "small", "tabIndex", "children", "text", "disabled", "intent", "active", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * React Router's NavLink wrapped in blueprint styling.
 */
var LinkButton = exports.LinkButton = /*#__PURE__*/function (_Component) {
  function LinkButton() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(LinkButton, _Component);
  var _proto = LinkButton.prototype;
  _proto.render = function render() {
    var _classNames;
    var _this$props = this.props,
      exact = _this$props.exact,
      end = _this$props.end,
      to = _this$props.to,
      icon = _this$props.icon,
      rightIcon = _this$props.rightIcon,
      alignText = _this$props.alignText,
      fill = _this$props.fill,
      large = _this$props.large,
      loading = _this$props.loading,
      minimal = _this$props.minimal,
      small = _this$props.small,
      tabIndex = _this$props.tabIndex,
      children = _this$props.children,
      text = _this$props.text,
      disabled = _this$props.disabled,
      intent = _this$props.intent,
      active = _this$props.active,
      originalClassName = _this$props.className,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var _className = (0, _classnames["default"])(_core.Classes.BUTTON, (_classNames = {}, _classNames[_core.Classes.ACTIVE] = active, _classNames[_core.Classes.DISABLED] = disabled, _classNames[_core.Classes.FILL] = fill, _classNames[_core.Classes.LARGE] = large, _classNames[_core.Classes.LOADING] = loading, _classNames[_core.Classes.MINIMAL] = minimal, _classNames[_core.Classes.SMALL] = small, _classNames), _core.Classes.alignmentClass(alignText), _core.Classes.intentClass(intent), originalClassName);
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, _extends({
      to: disabled ? "#" : to,
      end: end != null ? end : exact,
      className: function className(_ref) {
        var _classNames2;
        var isActive = _ref.isActive;
        return (0, _classnames["default"])(_className, (_classNames2 = {}, _classNames2[_core.Classes.ACTIVE] = isActive, _classNames2));
      },
      tabIndex: disabled ? -1 : tabIndex,
      "aria-disabled": disabled || undefined,
      onClick: disabled ? function (event) {
        event.preventDefault();
      } : extra.onClick
    }, extra), loading && /*#__PURE__*/_react["default"].createElement(_core.Spinner, {
      key: "loading",
      className: _core.Classes.BUTTON_SPINNER,
      size: _core.IconSize.LARGE
    }), /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      key: "leftIcon",
      icon: icon
    }), (text || children) && /*#__PURE__*/_react["default"].createElement("span", {
      key: "text",
      className: _core.Classes.BUTTON_TEXT
    }, text, children), /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      key: "rightIcon",
      icon: rightIcon
    }));
  };
  return LinkButton;
}(_react.Component);